import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-screenaccessthree',
  templateUrl: './usr-screenaccessthree.component.html',
  styleUrls: ['./usr-screenaccessthree.component.css']
})
export class UsrScreenaccessthreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
